import { render, staticRenderFns } from "./distributionStatistics.vue?vue&type=template&id=3a7807dc&scoped=true&"
import script from "./distributionStatistics.vue?vue&type=script&lang=js&"
export * from "./distributionStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7807dc",
  null
  
)

export default component.exports